import * as React from "react"
import { cn } from "../utils/cn"
import { Badge } from "./ui/badge"
import { MinusIcon, TrendingUpIcon, TrendingDownIcon } from "lucide-react"

const DeltaContext = React.createContext(null)
function useDeltaValue() {
  const ctx = React.useContext(DeltaContext)
  if (!ctx) throw new Error("DeltaIcon/DeltaValue must be used inside `Delta`.")
  return ctx.value
}

export function Delta({ className, value, variant = "default", ...props }) {
  return (
    <DeltaContext.Provider value={{ value }}>
      {variant === "badge" ? (
        <Badge
          className={cn(
            "gap-1 border-none tabular-nums [&_svg]:size-3.5 [&_svg]:shrink-0",
            value > 0 ? "bg-emerald-500/10 text-emerald-500" : value < 0 ? "bg-red-500/10 text-red-500" : "bg-muted text-muted-foreground",
            className
          )}
          {...props}
        />
      ) : (
        <div
          className={cn(
            "inline-flex items-center gap-1 text-muted-foreground tabular-nums text-xs",
            "[&_svg]:size-3 [&_svg]:shrink-0",
            value > 0 && "text-emerald-600 dark:text-emerald-400",
            value < 0 && "text-rose-600 dark:text-rose-400",
            className
          )}
          {...props}
        />
      )}
    </DeltaContext.Provider>
  )
}

export function DeltaIcon({ className, ...props }) {
  const value = useDeltaValue()
  if (!value) return <MinusIcon className={className} {...props} />
  return value > 0 ? <TrendingUpIcon className={className} {...props} /> : <TrendingDownIcon className={className} {...props} />
}

export function DeltaValue({ className, precision = 1, suffix = "%", absolute = true, ...props }) {
  const value = useDeltaValue()
  const formatted = (absolute ? Math.abs(value) : value).toFixed(precision)
  return (
    <span className={cn("tabular-nums", className)} {...props}>
      {formatted}
      {suffix}
    </span>
  )
}